import { useMemo } from "react";
import { authAPI } from "../../../api/auth";
import { useLatestQuery } from "../../../api/useLatestQuery";
import { AvatarColor, assignAvatarColors, avatarColorFor } from "./avatarColor";

/**
 * Returns a stable per-candidate color mapping across the user's entire
 * verified-profile set. Allocation is collision-free up to the palette size;
 * with more profiles than colors the overflow falls back to the per-id hash.
 *
 * Uses the same react-query key as the rest of the app's profile reads, so we
 * don't trigger an extra fetch.
 */
export function useAvatarColors() {
  const { data: profilesResult } = useLatestQuery(
    ["authAPI.myVerifiedProfiles"],
    () => authAPI.myVerifiedProfiles({})
  );

  const map = useMemo(() => {
    const ids = (profilesResult?.verifiedProfiles ?? []).map((p) => p.candidateId);
    return assignAvatarColors(ids);
  }, [profilesResult]);

  return useMemo(
    () => ({
      get(candidateId: number): AvatarColor {
        return map.get(candidateId) ?? avatarColorFor(candidateId);
      },
    }),
    [map]
  );
}
